<div class="efficiency-analysis">
  <div class="header">
    <app-back-button [title]="'module.efficiencyAnalysis.moduleName' | translate" (backClicked)="gotoDashboard()"> </app-back-button>

    <div class="buttons">
      <div class="add-object">
        <div class="add-btn">
          <button
            class="btn btn-outline-primary"
            [class.-active]="showTree"
            (click)="addObject()"
            [disabled]="showUndefinedBuildingsBanner || disableAddObjectButton"
          >
            {{ 'module.efficiencyAnalysis.addObjectButtonText' | translate }}
          </button>
        </div>
        <div class="tree-container" *ngIf="showTree">
          <app-add-object-tree [showTree]="showTree" [buildingsWithoutEA]="buildingsWithoutEA" (isProcessDone)="refreshPage($event)"></app-add-object-tree>
        </div>
      </div>
      <div class="efficiency-analysis-config" *ngIf="!!authService.permissions.EFFICIENCY_ANALYSIS_UPDATE">
        <button title="button-dialog" (click)="showConfigDialog()">
          <span class="fa fa-cog"></span>
        </button>
      </div>
    </div>
  </div>

  <div class="body" *ngIf="showBody()">
    <div class="filter">
      <mat-form-field class="dropdown">
        <mat-label>{{ 'module.efficiencyAnalysis.objectTypePlaceholderText' | translate }}</mat-label>
        <mat-select [formControl]="objectTypeForm" disableOptionCentering panelClass="panel-class-object-type" (click)="toggleBuildingTypeFilter()">
          <mat-select-trigger>
            {{ objectTypeText }}
          </mat-select-trigger>
          <mat-option class="object-types" value="objectTypeText">
            <app-building-type-filter
              [reset]="resetBuildingType"
              (updateSelectedText)="onUpdateSelectedText($event)"
              (updateBuildingWithEa)="onUpdateBuildingWithEa($event)"
            ></app-building-type-filter>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="date-picker label picker-spacing">
        <mat-label>{{ 'module.efficiencyAnalysis.startDatePlaceholderText' | translate }}</mat-label>
        <input matInput readonly [matDatepicker]="picker1" [(ngModel)]="startDate" [max]="endDate" autocomplete="off" />
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1 (opened)="clickFilterElement()"></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="date-picker label picker-spacing">
        <mat-label>{{ 'module.efficiencyAnalysis.endDatePlaceholderText' | translate }}</mat-label>
        <input matInput readonly [matDatepicker]="picker2" [(ngModel)]="endDate" [min]="startDate" [max]="maxDate" autocomplete="off" />
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2 (opened)="clickFilterElement()"></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="dropdown">
        <mat-label>{{ 'module.efficiencyAnalysis.electricityPlaceholderText' | translate }}</mat-label>
        <mat-select [formControl]="electricityColorForm" multiple disableOptionCentering panelClass="panel-class-color" (click)="clickFilterElement()">
          <mat-option *ngFor="let e of electricityCheckboxData" [value]="e.color" (click)="storeSelectedColorElectricity(e)">
            <div class="color-label">
              <div class="color" [ngStyle]="{ 'background-color': e.hexColor }"></div>
              <div class="name">{{ e.name }}</div>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="dropdown">
        <mat-label>{{ 'module.efficiencyAnalysis.heatPlaceholderText' | translate }}</mat-label>
        <mat-select [formControl]="heatColorForm" multiple disableOptionCentering panelClass="panel-class-color" (click)="clickFilterElement()">
          <mat-option *ngFor="let e of heatCheckboxData" [value]="e.color" (click)="storeSelectedColorHeat(e)">
            <div class="color-label">
              <div class="color" [ngStyle]="{ 'background-color': e.hexColor }"></div>
              <div class="name">{{ e.name }}</div>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="filter-buttons">
        <button class="btn btn-outline-primary filter-btn" (click)="runFilter()">
          <span class="fa fa-filter"></span> {{ 'module.efficiencyAnalysis.filterButtonText' | translate }}
        </button>
        <button class="btn btn-outline-primary clear-filter-btn" (click)="resetFilter()">
          {{ 'module.efficiencyAnalysis.clearFilterButtonText' | translate }}
        </button>
      </div>
    </div>

    <div class="object-dropdown" [class.-active]="b.isSelected" *ngFor="let b of uniqueBuildingsWithEA">
      <div class="dropdown-value" (click)="updateActiveStatus(b)">
        <img alt="building-type-img" src="./assets/icons/objectTypes/{{ b?.buildingType.imageName }}" />
        <div class="select">{{ b.buildingType.name }}</div>
        <span class="fa fa-chevron-down chevron fa-lg"></span>
      </div>

      <div class="dropdown-content" *ngIf="b.isSelected">
        <app-building-efficiency-details
          [selectedBuildingType]="b"
          [buildingsWithEA]="buildingsWithEA"
          [uniqueBuildingsWithEA]="uniqueBuildingsWithEA"
          (showTree)="this.showTree = $event"
          (isProcessDone)="refreshPage($event)"
          (reinitializeEfficiencyAnalysis)="initializeEfficiencyAnalysis()"
        ></app-building-efficiency-details>
      </div>
    </div>
  </div>

  <div class="empty-results" *ngIf="!isFilterOn && uniqueBuildingsWithEA.length === 0 && !overlayLoaderService.isLoading">
    <div class="empty-results-text" *ngIf="!showUndefinedBuildingsBanner">
      <div>
        <p>
          {{ 'module.efficiencyAnalysis.emptyResultsText1' | translate }}<br />
          {{ 'module.efficiencyAnalysis.emptyResultsText2' | translate }}
        </p>
        <p class="energymap-button">
          <button class="btn btn-outline-primary" (click)="goToMap()">
            {{ 'module.efficiencyAnalysis.undefinedBuildingsPopup.buttonText' | translate }}
          </button>
        </p>
      </div>
    </div>

    <app-empty-buildings-popup *ngIf="showUndefinedBuildingsBanner" [hideClose]="true"> </app-empty-buildings-popup>
  </div>

  <app-notification-card
    class="app-notification-card"
    type="info"
    text="{{ 'module.efficiencyAnalysis.noResultsFoundText' | translate }}"
    *ngIf="isFilterOn && uniqueBuildingsWithEA.length === 0 && !this.overlayLoaderService.isLoading"
  >
  </app-notification-card>

  <div class="overlay" *ngIf="hasUndefinedBuildings">
    <app-empty-buildings-popup *ngIf="hasUndefinedBuildings" [hideClose]="false" (closeEvent)="close()"> </app-empty-buildings-popup>
  </div>
</div>
